/*
 * Copyright (c) 2023 by N-Ach (Pvt) Ltd
 *
 * ╔═╗ ╔╗    ╔═══╗  ╔╗
 * ║║╚╗║║    ║╔═╗║  ║║
 * ║╔╗╚╝║    ║║ ║╠══╣╚═╗
 * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
 * ║║ ║║║╚══╝║╔═╗║╚═╣║║║
 * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information
 * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential
 * Information and shall use it only in accordance with the terms
 * of the license agreement you entered into with N-Ach (Pvt) Ltd.
 *
 *
 * @Author Dilhari Jayathunga
 * @Date 20/11/2023
 */

import { Add, Close } from '@mui/icons-material'
import { Backdrop, Button, CircularProgress, Dialog, DialogContent, FormControl, FormControlLabel, IconButton, Radio, RadioGroup, Typography } from '@mui/material'
import React, { useContext, useEffect, useState } from 'react'
import styles from "./SelectAddress.module.css"
import AddAddress from '../Address/AddAddress'
import { useGetAllAddressesQuery } from '../../Store/Services/AddressService'
import CheckoutContext from '../../Context/CheckoutContext'
import { SET_ADDRESS_DETAILS } from '../../Pages/CheckoutPage'
import { skipToken } from "@reduxjs/toolkit/dist/query";
import { useLazyGetAllAddressesQuery } from '../../Store/Services/AddressService'

const SelectAddress = ({ open, onClose }) => {

    const [openNew, setOpenNew] = useState(false)
    // const { data, isSuccess, isLoading } = useGetAllAddressesQuery();
    const [fetchAddresses, { data, isSuccess, isLoading }] = useLazyGetAllAddressesQuery();

    const { checkoutData, dispatch } = useContext(CheckoutContext);

    useEffect(() => {
        if (open) {
            fetchAddresses();
        }
    }, [open, fetchAddresses]);

 useEffect(() => {
        if (isSuccess && data?.length) {
            const firstAddress = data[0];
            dispatch({
                type: SET_ADDRESS_DETAILS,
                payload: {
                    userContactId: firstAddress.userContactId,
                    location: firstAddress.location,
                    areaId: firstAddress.areaId,
                    areaName: firstAddress.areaName,
                    stateId: firstAddress.stateId,
                    stateName: firstAddress.stateName,
                    addressLine1: firstAddress.addLine1,
                    addressLine2: firstAddress.addLine2,
                    addressLine3: firstAddress.addLine3,
                },
            });
        }
    }, [data, isSuccess, dispatch]);

    const handleAddressChange = (add) => {
        dispatch({ type: SET_ADDRESS_DETAILS, payload: {
            userContactId: add?.userContactId,
            location: add?.location,
            areaId: add?.areaId,
            areaName: add?.areaName,
            stateId: add?.stateId,
            stateName: add?.stateName,
            addressLine1: add?.addLine1,
            addressLine2: add?.addLine2,
            addressLine3: add?.addLine3,
        }})
    }
// console.log(checkoutData.userContactId);
    return (
        <Dialog
            fullWidth={true}
            maxWidth="sm"
            open={open}
            aria-labelledby="address-select-dialog"
        >
            {isLoading && (
                <Backdrop
                    sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
                    open={isLoading}
                >
                    <CircularProgress color="inherit" />
                </Backdrop>
            )}
            <DialogContent className={styles.dialog}>
                <div className={styles.headingContainer}>
                    <Typography fontWeight={600} variant={"h6"}>Address</Typography>
                    <IconButton disabled={checkoutData.userContactId==undefined} className={styles.closeButton} onClick={() => onClose()}><Close /></IconButton>
                </div>
                <div className={styles.addAddressContainer}>
                    <Button onClick={() => setOpenNew(true)}>
                        <Add/> Add New Address
                    </Button>
                </div>
                {isSuccess && !isLoading &&
                    data.map(address => (
                        <div key={address.userContactId} className={styles.addressContainer}>
                            <FormControl>
                                {/* <RadioGroup
                                    style={{ alignSelf: "start" }}
                                    color="secondary"
                                > */}
                                <FormControlLabel
                                    value={address.userContactId}
                                    checked={checkoutData.userContactId == address.userContactId}
                                    onChange={() => handleAddressChange(address)}
                                    control={<Radio />}
                                    label={
                                        <div>
                                            <Typography variant='h6'>
                                                {address.contactName}
                                            </Typography>
                                            <Typography>
                                                {address.addLine3}, {address.addLine2}, {address.addLine1}
                                            </Typography>
                                            <Typography>
                                                {address.areaName}, {address.stateName}
                                            </Typography>
                                        </div>
                                    } />
                                {/* </RadioGroup> */}
                            </FormControl>
                        </div>
                    ))
                }
                <Button
                    variant='contained'
                    className={styles.submitButton}
                    onClick={() => onClose()}
                    disabled={checkoutData.userContactId==undefined}
                >
                    Select
                </Button>
            </DialogContent>
            <AddAddress open={openNew} handleClose={() => setOpenNew(false)} />
        </Dialog>
    )
}

export default SelectAddress